module.exports = __webpack_public_path__ + "img/brand-left-circle.58fca116.svg";